export const NAME = "appNavigator"

const content = { NAME }
export default content
